import { useContext, useEffect } from "react"
import { FormContext } from "../../context/formContext"
import { useFormikContext } from "formik"
import { InputText as Input } from "primereact/inputtext"
import fieldVisibility from "../../helpers/fieldVisibility"
import { TRIM_TYPES, trimTextValue } from "./helpers/trimTextValue"
import styles from "../../styles/Form.module.css"

export default function TypeZipcode({ field, block, index }) {
  const formik = useFormikContext()
  const form = useContext(FormContext)
  let isDisabled = form ? form.blocksSaved[block] : false
  isDisabled = field.read_only ? true : isDisabled

  const checkIfRequired = () => {
    try {
      return JSON.parse(field.field_validation.required[0])
    } catch (error) {
      return false
    }
  }

  useEffect(() => {
    // Register field as loading in FormContext
    form && form.registerLoadingField(field)

    // Notify FormContext that field is loaded
    form && form.completeLoadingField(field)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const isRequired = checkIfRequired()

  return (
    <div
      className={styles.field}
      style={{
        order: index,
        display: fieldVisibility(field.field_visibility),
      }}
    >
      <label className={styles.label}>
        {field.field_label}
        {isRequired && <span className={styles.asterisk}> *</span>}
      </label>
      {field.field_description && (
        <div className={styles.description}>{field.field_description}</div>
      )}
      <div className={styles.value}>
        <Input
          name={field.field_name}
          disabled={isDisabled}
          value={formik.values[field.field_name]}
          onChange={({ target: { value } }) =>
            formik.setFieldValue(field.field_name, value)
          }
          onBlur={({ target: { value } }) =>
            formik.setFieldValue(
              field.field_name,
              trimTextValue(value, TRIM_TYPES.BOTH),
              true,
            )
          }
        />
      </div>
    </div>
  )
}
